import React from "react"
import Link from 'gatsby-link'

// Get the icon we need
import gridicon from './grid-icon.png'

/**
 * LocationMicoNav displays a simple icon that jumps users from a location page to the location index
 */

class LocationMicroNav extends React.Component {
  render() {
    return (
      <div>
        <Link to="/locations" className="pfb-location-micronav-container">
          <img className="pfb-location-micronav-icon" src= { gridicon } alt="Icon of nine dots, returns user to locations landing page" />
          <p className="pfb-location-micronav-text">Return to Locations</p>
        </Link>
      </div>
    )
  }
}

export default LocationMicroNav


// WEBPACK FOOTER //
// ./src/components/LocationMicroNav/index.js